// extracted by mini-css-extract-plugin
export var copyBtn = "ED-b44qd";